/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import GlobalProperty from './global-property';
import GlobalPropertyDetail from './global-property-detail';
import GlobalPropertyUpdate from './global-property-update';
import GlobalPropertyDeleteDialog from './global-property-delete-dialog';

const GlobalPropertyRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<GlobalProperty />} />
    <Route path="new" element={<GlobalPropertyUpdate />} />
    <Route path=":id">
      <Route index element={<GlobalPropertyDetail />} />
      <Route path="edit" element={<GlobalPropertyUpdate />} />
      <Route path="delete" element={<GlobalPropertyDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GlobalPropertyRoutes;
